const makeFirstLetterInEveryWordUpperCase = (data: string): string => {
  return data.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
};

export { makeFirstLetterInEveryWordUpperCase };
